module.exports = __webpack_public_path__ + "./docs/img/big-icon-constructor.726587be24e3c01f304bfa11439c9725.svg";